import { ShieldCheck } from "lucide-react";
import { COMPANY } from "../lib/content";

const SECTIONS = [
    {
        title: "1. Information We Collect",
        body: "When you submit a form on this website (contact, demo or investor enquiry), we collect the details you provide: name, email address, phone number, company name and your message. We also collect standard technical data such as IP address and browser type for security and analytics purposes.",
    },
    {
        title: "2. Anti-Bot & Data Protection Measures",
        body: "Our forms are protected by multiple anti-bot layers — honeypot fields, submission timing checks and per-source rate limiting — so that automated bots and scrapers cannot harvest or inject data. Form submissions are only accepted from genuine human sessions, and no information is shared with any third party without verification and consent.",
    },
    {
        title: "3. How We Use Your Information",
        body: "We use submitted information solely to respond to your enquiry, schedule demos, discuss our services or evaluate investor interest. We do not sell, rent or trade your personal information to anyone.",
    },
    {
        title: "4. Data Storage & Security",
        body: "Your data is stored in secured databases with access restricted to authorised team members. We apply industry-standard safeguards, and form data is transmitted over encrypted (HTTPS) connections.",
    },
    {
        title: "5. Cookies & Translation",
        body: "We use a small number of functional cookies — for example, to remember your preferred display language via Google Translate. Analytics cookies may be used to understand website traffic in aggregate.",
    },
    {
        title: "6. Third-Party Services",
        body: "We link to WhatsApp, Google Maps and social-media platforms. When you interact with those services, their own privacy policies apply.",
    },
    {
        title: "7. Your Rights",
        body: "You may request access to, correction of, or deletion of your personal data at any time by contacting us through the Contact page or WhatsApp at " + COMPANY.phoneDisplay + ".",
    },
    {
        title: "8. Updates",
        body: "This policy may be updated periodically. The latest version will always be available on this page.",
    },
];

export default function Privacy() {
    return (
        <div className="mx-auto max-w-4xl px-4 py-20 sm:px-6 lg:py-24" data-testid="privacy-page">
            <p className="font-mono2 text-xs uppercase tracking-[0.25em] text-cyan-400">Legal</p>
            <h1 className="mt-3 font-display text-4xl font-extrabold text-white" data-testid="privacy-heading">Privacy Policy</h1>
            <p className="mt-3 text-sm text-slate-500">Last updated: September 2026 · {COMPANY.legal}</p>
            <div className="mt-8 flex items-start gap-3 rounded-2xl border border-cyan-500/25 bg-cyan-500/5 p-5">
                <ShieldCheck className="mt-0.5 h-5 w-5 shrink-0 text-cyan-400" />
                <p className="text-sm leading-relaxed text-slate-300">
                    Your trust matters to us. This website never exposes or shares your information through bots, and no
                    data leaves our systems without your consent.
                </p>
            </div>
            <div className="mt-10 space-y-8">
                {SECTIONS.map((s) => (
                    <section key={s.title} data-testid={`privacy-section-${s.title.split(".")[0]}`}>
                        <h2 className="font-display text-lg font-bold text-white">{s.title}</h2>
                        <p className="mt-2.5 text-sm leading-relaxed text-slate-400">{s.body}</p>
                    </section>
                ))}
            </div>
        </div>
    );
}
